import React, { useState, useEffect } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "../mock/mock";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), 5000);
    return () => clearInterval(t);
  }, []);

  const current = TESTIMONIALS[idx];

  return (
    <section className="py-20 md:py-28 bg-slate-50 relative overflow-hidden">
      <div className="absolute top-10 left-10 text-teal-100">
        <Quote className="w-40 h-40" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-100 text-teal-700 text-xs font-semibold tracking-wider uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-teal-600" /> Traveller Stories
        </div>
        <h2 className="mt-4 text-3xl md:text-5xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
          Loved by 15,000+ travellers
        </h2>

        <div key={current.id} className="mt-12 animate-in fade-in duration-500">
          <div className="flex justify-center gap-1 mb-6">
            {[...Array(current.rating)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-orange-500 text-orange-500" />
            ))}
          </div>
          <blockquote className="text-xl md:text-2xl text-slate-800 leading-relaxed max-w-3xl mx-auto font-medium">
            &ldquo;{current.text}&rdquo;
          </blockquote>
          <div className="mt-8 flex items-center justify-center gap-4">
            <img
              src={current.avatar}
              alt={current.name}
              className="w-14 h-14 rounded-full object-cover border-4 border-white shadow-lg"
            />
            <div className="text-left">
              <div className="font-bold text-slate-900">{current.name}</div>
              <div className="text-sm text-slate-500">{current.place}</div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex items-center justify-center gap-3">
          <button
            onClick={() => setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
            className="w-10 h-10 rounded-full bg-white border border-slate-200 hover:bg-teal-600 hover:text-white hover:border-teal-600 transition"
            aria-label="prev"
          >
            <ChevronLeft className="w-4 h-4 mx-auto" />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-teal-600" : "w-2 bg-slate-300"}`}
              />
            ))}
          </div>
          <button
            onClick={() => setIdx((i) => (i + 1) % TESTIMONIALS.length)}
            className="w-10 h-10 rounded-full bg-white border border-slate-200 hover:bg-teal-600 hover:text-white hover:border-teal-600 transition"
            aria-label="next"
          >
            <ChevronRight className="w-4 h-4 mx-auto" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
